var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#711CF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9618 9.13443C16.7826 8.95519 16.4971 8.95519 16.3178 9.13443L12.8579 12.5944C12.8032 12.6461 12.7667 12.7129 12.7424 12.7858L12.1774 14.6722C12.1288 14.8332 12.1744 15.0064 12.2928 15.1248C12.3779 15.2129 12.4964 15.2585 12.6148 15.2585C12.6574 15.2585 12.7029 15.2524 12.7455 15.2403L14.6319 14.6753C14.7048 14.651 14.7716 14.6145 14.8233 14.5598L18.2833 11.0998C18.3683 11.0148 18.4169 10.8994 18.4169 10.7778C18.4169 10.6563 18.3683 10.5409 18.2833 10.4558L16.9618 9.13443Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9613 13.2537C17.7096 13.2537 17.5057 13.4578 17.5057 13.7094V16.7471C17.5057 17.166 17.165 17.5065 16.7462 17.5065H10.6708C10.252 17.5065 9.91132 17.166 9.91132 16.7471V10.6716C9.91132 10.2527 10.252 9.91218 10.6708 9.91218H13.7085C13.9602 9.91218 14.1642 9.70808 14.1642 9.45652C14.1642 9.20495 13.9602 9.00085 13.7085 9.00085H10.6708C9.7495 9.00085 9 9.7505 9 10.6716V16.7471C9 17.6682 9.7495 18.4179 10.6708 18.4179H16.7462C17.6675 18.4179 18.417 17.6682 18.417 16.7471V13.7094C18.417 13.4578 18.213 13.2537 17.9613 13.2537Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularEdit);
export default __webpack_public_path__ + "static/media/circularEdit.1bc34135b27e548c124b1acb79540c7f.svg";
export { ForwardRef as ReactComponent };